import {isFolderSpecial} from 'utils/mediafire';
import type {Store, Actions} from 'store/slices/transfers/types';

export function upload(state: Store, action: Actions['Upload']) {
  const {id, files, queue} = action.payload;
  const targetId = isFolderSpecial(id) ? 'myfiles' : id;
  if (id) {
    state.upload = targetId;
    state.uploadWeb = undefined;
    state.uploadFiles = queue ? [...(state.uploadFiles || []), ...files] : files;
    state.uploadMinimized = Boolean(files) && !queue;
    state.uploadView = {files: [], folders: []};
    state.uploadItems = {};
    state.uploadQueue = queue ? true : false;
  } else {
    state.upload = null;
    state.uploadWeb = undefined;
    state.uploadFiles = undefined;
    state.uploadView = {files: [], folders: []};
    state.uploadItems = {};
    state.uploadQueue = false;
  }
}

export function uploadWeb(state: Store, action: Actions['UploadWeb']) {
  const {id, files} = action.payload;
  const targetId = isFolderSpecial(id) ? 'myfiles' : id;
  state.upload = targetId;
  state.uploadWeb = files;
  state.uploadFiles = undefined;
  state.uploadView = {files: [], folders: []};
  state.uploadItems = {};
}

export function uploadSync(state: Store, action: Actions['UploadSync']) {
  const {items} = action.payload;
  if (state.upload) {
    items.forEach(item => {
      const path = item.name;
      if (path) {
        state.uploadItems[path] = item;
        if (!state.uploadView.files.includes(path)) {
          state.uploadView.files.push(path);
          state.uploadView.files.sort((a, b) =>
            state.uploadItems[a].size - state.uploadItems[b].size
          )
        }
      }
    });
  }
}

export function uploadMinimize(state: Store, action: Actions['UploadMinimize']) {
  const {minimized} = action.payload;
  state.uploadMinimized = minimized;
}

export function downloadBulk(state: Store, action: Actions['DownloadBulk']) {
  state.downloadMinimized = true;
  state.downloadBulk.push(action.payload);
}

export function downloadSync(state: Store, action: Actions['DownloadSync']) {
  if (state.downloadBulk.length > 0) {
    const {items} = action.payload;
    items.forEach(item => {
      const path = item.id;
      if (path) {
        state.downloadItems[path] = item;
        if (!state.downloadView.files.includes(path)) {
          state.downloadView.files.push(path);
        }
      }
    });
  }
}

export function downloadMinimize(state: Store, action: Actions['DownloadMinimize']) {
  const {minimized} = action.payload;
  state.downloadMinimized = minimized;
}

export function downloadClose(state: Store) {
  state.downloadBulk = [];
  state.downloadItems = {};
  state.downloadView = {files: [], folders: []};
}
